import { FeatureFlags } from '../shared/enums/feature-flags';
import { FeatureFlagNode } from '../shared/interfaces';

export const featureflagSections = {
  app: [
    FeatureFlags.ENABLE_STUDENT_INBOX,
    FeatureFlags.SAVE_ACTIVITY_ANYWHERE,
    FeatureFlags.AUTOSAVE,
    FeatureFlags.EXPERIMENTAL_BROWSER,
    FeatureFlags.CDN_ACTIVITIES,
    FeatureFlags.CDN_ASSETS,
    FeatureFlags.DND_READ_ALOUD,
    FeatureFlags.TEACHER_MODE,
    FeatureFlags.ENABLE_ARBITRARY_LAUNCHING,
    FeatureFlags.SAVE_DATA_FOLDER,
    FeatureFlags.RETURN_TO_REFERRER,
    FeatureFlags.EXPANDABLE_CONTENT,
    FeatureFlags.USE_AMIRA_TTS,
    FeatureFlags.ENABLE_SENTRY_LOGGING,
    FeatureFlags.ENABLE_LOGGING_SERVICE,
  ],
  content: [
    FeatureFlags.EARLY_ACCESS,
    FeatureFlags.CONTENT_TESTING,
    FeatureFlags.LIVE_CONTENT,
    FeatureFlags.SANDBOX,
    FeatureFlags.DEV_HOME_PAGE,
  ],
  debug: [
    FeatureFlags.AUTO_ENABLE_NEXT,
    FeatureFlags.SKIP_SPOT_SCENES,
    FeatureFlags.REPLAY_BUTTON,
    FeatureFlags.RANDOMIZE_ANSWER_CHOICES,
    FeatureFlags.SHOW_ACTIVITY_VERSION,
    FeatureFlags.KB_DEBUG,
    FeatureFlags.COMPONENT_TEST_PAGE,
    FeatureFlags.SIGNAL_R_SERVICE,
    FeatureFlags.FORCE_DISPLAY_ELAPSED_TIMER,
  ],
  user: [
    FeatureFlags.AUTHENTICATE,
    FeatureFlags.USE_KB,
    FeatureFlags.USE_ASSIGNMENT_API,
    FeatureFlags.USE_CLICKSTREAM,
  ],
};

export const featureFlagLabels = {
  [FeatureFlags.TEACHER_MODE]: 'works with the "teacher" role only',
  [FeatureFlags.REPLAY_BUTTON]: 'Requires Reload',
  [FeatureFlags.AUTHENTICATE]: 'Requires Reload',
  [FeatureFlags.USE_KB]: 'Requires Reload',
  [FeatureFlags.USE_CLICKSTREAM]: 'Requires Reload',
  [FeatureFlags.EARLY_ACCESS]: 'Requires Reload',
  [FeatureFlags.SANDBOX]: 'DEV Only | Requires Reload',
  [FeatureFlags.CONTENT_TESTING]: 'DEV Only | Requires Reload',
  [FeatureFlags.COMPONENT_TEST_PAGE]: 'DEV Only | Requires Reload',
  [FeatureFlags.DEV_HOME_PAGE]: 'Requires Reload',
  [FeatureFlags.LIVE_CONTENT]: 'Requires Reload',
  [FeatureFlags.ENABLE_STUDENT_INBOX]:
    'Enables Student Inbox Behavior. Requires Reload',
  [FeatureFlags.USE_AMIRA_TTS]:
    'Requires Reload | Requires Amira Auth (See documentation)',
  [FeatureFlags.FORCE_DISPLAY_ELAPSED_TIMER]: 'Requires Reload',
  [FeatureFlags.ENABLE_SENTRY_LOGGING]: 'Requires Reload',
};

export const featureFlagNodeMap: Map<string, FeatureFlagNode> = new Map([
  [
    FeatureFlags.AUTHENTICATE,
    {
      children: [
        FeatureFlags.USE_KB,
        FeatureFlags.USE_CLICKSTREAM,
        FeatureFlags.USE_ASSIGNMENT_API,
      ],
    },
  ],
  [
    FeatureFlags.USE_KB,
    {
      parent: FeatureFlags.AUTHENTICATE,
      children: [
        FeatureFlags.USE_ASSIGNMENT_API,
        FeatureFlags.ENABLE_STUDENT_INBOX,
      ],
    },
  ],
  [
    FeatureFlags.USE_CLICKSTREAM,
    { parent: FeatureFlags.AUTHENTICATE, children: [] },
  ],
  [
    FeatureFlags.USE_ASSIGNMENT_API,
    { parent: FeatureFlags.USE_KB, children: [] },
  ],
  [
    FeatureFlags.ENABLE_STUDENT_INBOX,
    { parent: FeatureFlags.USE_KB, children: [] },
  ],
]);
